// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5839) return "static/chunks/5839-ea6ce8341b4e5e29.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4284 ? "ba1712fc" : chunkId) + "." + {"1235":"e725e9389c255c77","3616":"e725e9389c255c77","4284":"c466ca9d52619002","6493":"7e6dee4102326b4d"}[chunkId] + ".js";
};